import React from "react";
import bannerimage from "../../Assest/new_logo_withshreebalaji.png";

export default function HeroSection() {
  return (
    <section
      className="relative min-h-[70vh] bg-cover bg-center"
      style={{
        backgroundImage: `url(${bannerimage})`,
      }}
    >
      {/* TOP SHADOW GRADIENT OVERLAY */}
      {/* <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/30"></div> */}

      {/* Content */}
      <div className="relative z-10 min-h-[70vh] flex items-center justify-center text-center text-black px-6">
        <div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg">
            TURNS DREAMS INTO REALITY!
          </h1>
          <p className="text-lg text-black-200 drop-shadow">
            ROBUTS FINTECH SOLUTIONS 
          </p>
        </div>
      </div>
    </section>
  );
}
